import React, { useEffect, useState } from "react";
import { useAuth as useOidcAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

const SignOutOidc = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ErrorPage = localStorage.getItem('errorPage'); 
    if (ErrorPage !== null && ErrorPage === "timeout") {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/unauthorized");
    } else if (ErrorPage !== null && ErrorPage === "invaliduser") {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/failed-authorization");
    } else {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
    setLoading(false);
    
  }, [navigate]);
  return <div>{loading ? "Signing out user info..." : "Signing out."}</div>;
};

export default SignOutOidc;
